import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import ProduitsAdminTable from "../../Tables/admin/produits/ProduitsAdminTable";
import SideBarAdmin from "../Layouts/SideBarAdmin/SideBarAdmin";
import TopBar from "../Layouts/TopBar/TopBar";

function ListeProduitsAdmin() {
  const [word1, setWord1] = useState("");
  const [word2, setWord2] = useState("");
  return (
    <div className="parametre-page">
      <TopBar index={3} />
      <SideBarAdmin index={3} />
      <div className="parametre-component m-tableau-bord pt-3 flex-r">
        <div className="admin-page-container">
          <div className="p4 p-xxl-3">
            <div className="row">
              <div className="col-md-12 maajjal-table-card px-3 py-4 ml-2 mr-3">
                <div className="col-md-12">
                  <h3 className="tb-mes-projet-titre mb-4">
                    Toutes les produits
                  </h3>
                </div>
                <div className="admin-projets-btn-ajout-container">
                  <NavLink
                    to={"/admin/ajouter-produits"}
                    type="button"
                    className="btn admin-projets-btn-ajout"
                  >
                    <AiOutlinePlus className="admin-projets-btn-ajout-icon" />{" "}
                    Ajouter un produit
                  </NavLink>
                </div>
                <div className="dashboard-commandes-filtre-container ">
                  <form className="row g-3 dashboard-commandes-filtre-form">
                    <div className="col-auto">
                      <label
                        htmlFor="staticEmail2"
                        className="dashboard-commandes-filtre-label"
                      >
                        Filtrer
                      </label>
                    </div>
                    <div className="col-auto">
                      <input
                        type="text"
                        className="form-control dashboard-commandes-filtre-input"
                        id="inputPassword2"
                        value={word1}
                        onChange={(e) => setWord1(e.target.value)}
                        placeholder="Produit"
                      />
                    </div>
                    <div className="col-auto">
                      <input
                        type="text"
                        value={word2}
                        onChange={(e) => setWord2(e.target.value)}
                        className="form-control dashboard-commandes-filtre-input"
                        id="inputPassword2"
                        placeholder="Commerçant"
                      />
                    </div>
                  </form>
                </div>

                <ProduitsAdminTable {...{ word1, word2 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListeProduitsAdmin;
